(function(){
    "use strict";
    
    angular
        .module("app")
        .component("addressDropdown", { // shipping-address-dropdown
            templateUrl: "src/app/addressDropdown/addressDropdown.html",
            controller: controller,
            bindings: {
                addresses: "<",
                certificates: "<",
                selectedAddress: "<",
                onAddressSelected: "&",
                isWorking: "<",
                certDisplay: "<",
                addCertDisplay: "<"
            }
        });

    function controller() {
        const $ctrl = this;
        $ctrl.addressNeedsCert = () => {
            if (!$ctrl.selectedAddress)
                return false;
            if ($ctrl.selectedAddress && $ctrl.certificates && $ctrl.certificates.some(c => $ctrl.selectedAddress.deas.some(dea => dea.identification_code === c.contact_dea)))
                return false;
            return true;
        }

        $ctrl.selectAddress = address => {
            $ctrl.selectedAddress = address;
            $ctrl.onAddressSelected({ address });
        };

        $ctrl.formatAddress = address => {
            if (!address) return "Select Address";

            let certLine = `<br><span class='text-danger'>CSOS Certificate: Not Found</span>`;
            if ($ctrl.certificates && $ctrl.certificates.some(c => address.deas.some(dea => dea.identification_code === c.contact_dea))) {
                certLine = `<br><span class='text-success'>CSOS Certificate: Yes</span>`;
            }

            return !address.customer_id
                ? `${address.first_name}`
                : `${address.first_name} ${address.last_name}` +
                (address.address1 ? `<br>${address.address1}` : '') +
                (address.address2 ? `<br>${address.address2}` : '') +
                `<br>${address.city_name}, ${address.state_code} ${address.zip_code}` +
                ($ctrl.certDisplay ? certLine : '');
        };

        // this puts <strong> around the name
        $ctrl.formatAddressForList = address => {
            let certLine = `<br><span class='text-danger'>CSOS Certificate: Not Found</span>`;
            if ($ctrl.certificates && $ctrl.certificates.some(c => address.deas.some(dea => dea.identification_code === c.contact_dea))) {
                certLine = `<br><span class='text-success'>CSOS Certificate: Yes</span>`;
            }

            return !address.customer_id
                ? `<strong>${address.first_name}</strong>`
                : `<strong>${address.first_name} ${address.last_name}</strong>` +
                (address.address1 ? `<br>${address.address1}` : '') +
                (address.address2 ? `<br>${address.address2}` : '') +
                `<br>${address.city_name}, ${address.state_code} ${address.zip_code}` +
                ($ctrl.certDisplay ? certLine : '');
        };

    }
    controller.$inject = [];
    
})()